import api from "../services/api";
import { push } from "react-router-redux";
import { stopSubmit } from "redux-form";
import { showError, setLoading } from "./common.actions";
import { setPagination } from "./admin.actions";
import { resetTable, setTableLoading } from "./table.actions";
import "../utils/arrays";

export const GET_INVOICES_START = "GET_INVOICES_START";
export const GET_INVOICES_SUCCESS = "GET_INVOICES_SUCCESS";
export const GET_INVOICES_CSV_SUCCESS = "GET_PROJECTS_CSV_SUCCESS";
export const GET_INVOICES_ERROR = "GET_INVOICES_ERROR";
export const GET_INVOICE_START = "GET_INVOICE_START";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_ERROR = "GET_INVOICE_ERROR";
export const CREATE_INVOICE_START = "CREATE_INVOICE_START";
export const CREATE_INVOICE_SUCCESS = "CREATE_INVOICE_SUCCESS";
export const CREATE_INVOICE_ERROR = "CREATE_INVOICE_ERROR";
export const UPDATE_INVOICE_START = "UPDATE_INVOICE_START";
export const UPDATE_INVOICE_SUCCESS = "UPDATE_INVOICE_SUCCESS";
export const UPDATE_INVOICE_ERROR = "UPDATE_INVOICE_ERROR";
export const UPLOAD_INVOICE_SUCCESS = "UPLOAD_INVOICE_SUCCESS";
export const GET_INVOICE_STATUS_START = "GET_INVOICE_STATUS_START";
export const GET_INVOICE_STATUS_SUCCESS = "GET_INVOICE_STATUS_SUCCESS";
export const GET_INVOICE_STATUS_ERROR = "GET_INVOICE_STATUS_ERROR";

export const INVOICE_INDEX_TABLE = "InvoiceIndexTable";
export const INVOICE_CREATE_FORM = "InvoiceCreateForm";
export const INVOICE_UPDATE_FORM = "InvoiceUpdateForm";

export function onGetInvoicesStart() {
  return {
    type: GET_INVOICES_START
  };
}

export function onGetInvoicesSuccess(data) {
  return {
    type: GET_INVOICES_SUCCESS,
    data
  };
}

export function onGetInvoicesCsvSuccess(data) {
  return {
    type: GET_INVOICES_CSV_SUCCESS,
    data
  };
}

export function onGetInvoicesError() {
  return {
    type: GET_INVOICES_ERROR
  };
}

export function onGetInvoiceStart() {
  return {
    type: GET_INVOICE_START
  };
}

export function onGetInvoiceSuccess(data) {
  return {
    type: GET_INVOICE_SUCCESS,
    data
  };
}

export function onGetInvoiceError() {
  return {
    type: GET_INVOICE_ERROR
  };
}

export function onCreateInvoiceStart() {
  return {
    type: CREATE_INVOICE_START
  };
}

export function onCreateInvoiceSuccess(data) {
  return {
    type: CREATE_INVOICE_SUCCESS,
    data
  };
}

export function onCreateInvoiceError() {
  return {
    type: CREATE_INVOICE_ERROR
  };
}

export function onUpdateInvoiceStart() {
  return {
    type: UPDATE_INVOICE_START
  };
}

export function onUpdateInvoiceSuccess(data) {
  return {
    type: UPDATE_INVOICE_SUCCESS,
    data
  };
}

export function onUpdateInvoiceError() {
  return {
    type: UPDATE_INVOICE_ERROR
  };
}

export function onUploadInvoiceSuccess() {
  return {
    type: UPLOAD_INVOICE_SUCCESS
  };
}

export function onGetInvoiceStatusStart() {
  return {
    type: GET_INVOICE_STATUS_START
  };
}

export function onGetInvoiceStatusSuccess(data) {
  return {
    type: GET_INVOICE_STATUS_SUCCESS,
    data
  };
}

export function onGetInvoiceStatusError() {
  return {
    type: GET_INVOICE_STATUS_ERROR
  };
}

export function getInvoices(loading = true) {
  return dispatch => {
    dispatch(
      setTableLoading({
        table: INVOICE_INDEX_TABLE,
        loading: loading
      })
    );
    dispatch(onGetInvoicesStart());

    api
      .getInvoices()
      .then(response => {
        const { data } = response.data;
        dispatch(onGetInvoicesSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetInvoicesError());
      })
      .finally(() => {
        dispatch(resetTable({ table: INVOICE_INDEX_TABLE }));
      });
  };
}

export function getInvoice(invoiceId) {
  return dispatch => {
    dispatch(onGetInvoiceStart());

    if (invoiceId) {
      dispatch(setLoading(true));

      api
        .getInvoice(invoiceId)
        .then(res => {
          const invoice = res.data.data;
          dispatch(onGetInvoiceSuccess(invoice));
        })
        .catch(() => {
          dispatch(onGetInvoiceError());
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    }
  };
}

export function createInvoice(invoice, loading = true) {
  return dispatch => {
    dispatch(setLoading(loading));
    dispatch(onCreateInvoiceStart());

    api
      .createInvoice(invoice)
      .then(res => {
        if (invoice.file && typeof invoice.file !== "string") {
          let formData = new FormData();
          formData.append("id", res.data.data.id);
          formData.append("file", invoice.file);

          api
            .uploadInvoice(formData)
            .then(() => {
              dispatch(onUploadInvoiceSuccess());

              const path = {
                pathname: "/member/projects/invoices",
                state: { showToast: true }
              };

              dispatch(push(path));
            })
            .catch(error => {
              dispatch(
                stopSubmit(INVOICE_CREATE_FORM, {
                  file: "File size must must not exceed 2 MB"
                })
              );
              dispatch(onCreateInvoiceError(error));
            })
            .finally(() => {
              dispatch(setLoading(false));
            });
        } else {
          dispatch(onCreateInvoiceSuccess(res.data));
        }
      })
      .catch(error => {
        dispatch(stopSubmit(INVOICE_CREATE_FORM, error.response.data.errors));
        dispatch(onCreateInvoiceError());
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
}

export function updateInvoice(invoice, companyId, loading = true) {
  return dispatch => {
    const id = _.get(invoice, "invoice_id") || _.get(invoice, "id");

    if (id) {
      dispatch(setLoading(loading));
      dispatch(onUpdateInvoiceStart());

      api
        .updateInvoice(id, invoice)
        .then(res => {
          if (invoice.file && typeof invoice.file !== "string") {
            let formData = new FormData();
            formData.append("file", invoice.file);
            formData.append("id", invoice.id);

            api
              .uploadInvoice(formData)
              .then(() => {
                dispatch(onUploadInvoiceSuccess());
              })
              .catch(error => {
                dispatch(
                  stopSubmit(formName || INVOICE_UPDATE_FORM, {
                    file: "File size must must not exceed 2 MB"
                  })
                );
                dispatch(onUpdateInvoiceError(error));
              });
          } else {
            dispatch(onUpdateInvoiceSuccess(res.data));

            if (companyId) {
              dispatch(push(`/admin/company/${companyId}/billing`));
            }
          }
        })
        .catch(error => {
          dispatch(stopSubmit(INVOICE_UPDATE_FORM, error.response.data.errors));
          dispatch(showError(error.response.data.message));
        })
        .finally(() => {
          dispatch(setLoading(false));
        });
    }
  };
}

export function removeInvoice(invoiceId, loading = true) {
  return dispatch => {
    if (invoiceId) {
      dispatch(setLoading(loading));

      api
        .removeInvoice(invoiceId)
        .then(() => {
          dispatch(getInvoices());
        })
        .catch(() => {})
        .finally(() => {
          dispatch(setLoading(false));
        });
    }
  };
}

export function downloadInvoice(invoiceId, download = false) {
  return () => {
    api
      .downloadInvoice(invoiceId)
      .then(res => {
        if (!download) {
          // Open in a new tab (view)
          window.open(res.data.data, "_blank");
        } else {
          // Download the file
          const fileUrl = res.data.data;
          const fileName = fileUrl.split("/").pop();

          // We will create a temp anchor element
          // This should allow us to download the files using HTML5 download attribute
          var temp_download = document.createElement("a");
          temp_download.href = fileUrl;
          temp_download.download = fileName.split("?")[0];

          // Append the a to the DOM and then trigger the click
          document.body.appendChild(temp_download);
          temp_download.click();

          // Remove the attribute from the DOM, we don't need it anymore.
          temp_download.remove();
        }
      })
      .catch(() => {});
  };
}

export function getInvoiceStatus() {
  return dispatch => {
    dispatch(onGetInvoiceStatusStart());

    api
      .getInvoiceStatus()
      .then(response => {
        const { data } = response.data;
        dispatch(onGetInvoiceStatusSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetInvoiceStatusError());
      })
      .finally(() => {});
  };
}

export function getAdminInvoices(filters = "") {
  return dispatch => {
    dispatch(onGetInvoicesStart());
    dispatch(setPagination({}));

    api
      .getAdminInvoices(filters)
      .then(response => {
        const { data } = response.data;

        dispatch(setPagination(data));
        dispatch(onGetInvoicesSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetInvoicesError());
      });
  };
}

export function getAdminInvoicesCSVData(filters = "") {
  return dispatch => {
    // dispatch(onGetInvoicesStart());

    api
      .getAdminInvoicesForCSV(filters)
      .then(response => {
        const { data } = response.data;
        dispatch(onGetInvoicesCsvSuccess(data));
      })
      .catch(error => {
        dispatch(showError(error.response.data.message));
        dispatch(onGetInvoicesError());
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/invoice.actions.js